import React, { Component }          from 'react';

import icClose                       from '../../img/ic_close.svg';

import "./MobileMenu.scss";

class SearchRecordings extends Component {

constructor(props) {
  super(props);

  this.state            = {
  }
}

render() {
  return (
    <div className={`mobile-menu__container ${this.props.show ? 'show' : ''}`}>
      <img onClick={this.props.hideMobileMenu.bind(this)} src={icClose} className="close-icon" />
      <div className="upper-header">
        <div className="title">Screen Test Admin</div>
      </div>
      <div className="link-container">
        <div className="links">
          <div onClick={() => this.props.changeScreen("RECORDINGS")} className="link">RECORDINGS</div>
          <div onClick={() => this.props.changeScreen("LOCATIONS")} className="link">LOCATIONS</div>
          <div onClick={() => this.props.changeScreen("ADMINS")} className="link">ADMINS</div>
          <div onClick={this.props.handleLogout} className="link">LOGOUT</div>
        </div>
      </div>
    </div>
  );
}
}

export default SearchRecordings;